import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import { skip } from 'rxjs';
import { MeasureTypeStore } from '../stores/measure-type.store';
import { MeasureType } from '../types/measure-type.interface';

@Injectable({ providedIn: 'root' })
export class AssetMeasureTypeOptionsService {
  private readonly store = inject(MeasureTypeStore);

  private readonly source = signal<MeasureType[]>([]);
  private activeAssetId: number | null = null;

  readonly options = computed(() =>
    this.source()
      .map(({ id, name }) => ({ value: id, label: name }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  );

  constructor() {
    inject(TranslocoService)
      .langChanges$.pipe(skip(1), takeUntilDestroyed())
      .subscribe(() => {
        if (this.activeAssetId !== null) void this.fetch(this.activeAssetId);
      });
  }

  load(assetId: number | null | undefined): void {
    const id = assetId ?? null;
    if (id === this.activeAssetId) return;
    this.activeAssetId = id;
    if (id !== null) void this.fetch(id);
    else this.source.set([]);
  }

  private async fetch(id: number): Promise<void> {
    try {
      this.source.set(await this.store.getByAssetId(id));
    } catch {
      this.activeAssetId = null;
      this.source.set([]);
    }
  }
}
